import { ENTERPRISE, FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
export const ProductLevelToSuiteBOHeaderTranslationKeyMap = {
  [FREE]: 'merchCards.businessObjectives.suite.FREE.header',
  [STARTER]: 'merchCards.businessObjectives.suite.STARTER.header',
  [PROFESSIONAL]: 'merchCards.businessObjectives.suite.PROFESSIONAL.header',
  [ENTERPRISE]: 'merchCards.businessObjectives.suite.ENTERPRISE.header'
};
export const ProductLevelAndProductLineToSuiteBOTranslationKeyMap = {
  [FREE]: {
    [MARKETING]: {
      title: 'merchCards.businessObjectives.suite.FREE.MARKETING.title'
    },
    [SALES]: {
      title: 'merchCards.businessObjectives.suite.FREE.SALES.title'
    },
    [SERVICE]: {
      title: 'merchCards.businessObjectives.suite.FREE.SERVICE.title'
    },
    [CMS]: {
      title: 'merchCards.businessObjectives.suite.FREE.CMS.title'
    },
    [OPERATIONS]: {
      title: 'merchCards.businessObjectives.suite.FREE.OPERATIONS.title'
    }
  },
  [STARTER]: {
    [MARKETING]: {
      title: 'merchCards.businessObjectives.suite.STARTER.MARKETING.title',
      subtext: 'merchCards.businessObjectives.suite.STARTER.MARKETING.subtext_jsx',
      extraQuantityUnits: 'merchCards.businessObjectives.suite.STARTER.MARKETING.extra_jsx'
    },
    [SALES]: {
      title: 'merchCards.businessObjectives.suite.STARTER.SALES.title',
      subtext: 'merchCards.businessObjectives.suite.STARTER.SALES.subtext_jsx'
    },
    [SERVICE]: {
      title: 'merchCards.businessObjectives.suite.STARTER.SERVICE.title',
      subtext: 'merchCards.businessObjectives.suite.STARTER.SERVICE.subtext_jsx'
    },
    [CMS]: {
      title: 'merchCards.businessObjectives.suite.STARTER.CMS.title'
    },
    [OPERATIONS]: {
      title: 'merchCards.businessObjectives.suite.STARTER.OPERATIONS.title'
    }
  },
  [PROFESSIONAL]: {
    [MARKETING]: {
      title: 'merchCards.businessObjectives.suite.PROFESSIONAL.MARKETING.title',
      subtext: 'merchCards.businessObjectives.suite.PROFESSIONAL.MARKETING.subtext_jsx',
      extraQuantityUnits: 'merchCards.businessObjectives.suite.PROFESSIONAL.MARKETING.extra_jsx'
    },
    [SALES]: {
      title: 'merchCards.businessObjectives.suite.PROFESSIONAL.SALES.title',
      subtext: 'merchCards.businessObjectives.suite.PROFESSIONAL.SALES.subtext_jsx',
      seatsSubtext: 'merchCards.businessObjectives.suite.PROFESSIONAL.SALES.seats_jsx'
    },
    [SERVICE]: {
      title: 'merchCards.businessObjectives.suite.PROFESSIONAL.SERVICE.title',
      subtext: 'merchCards.businessObjectives.suite.PROFESSIONAL.SERVICE.subtext_jsx',
      seatsSubtext: 'merchCards.businessObjectives.suite.PROFESSIONAL.SERVICE.seats_jsx'
    },
    [CMS]: {
      title: 'merchCards.businessObjectives.suite.PROFESSIONAL.CMS.title'
    },
    [OPERATIONS]: {
      title: 'merchCards.businessObjectives.suite.PROFESSIONAL.OPERATIONS.title'
    }
  },
  [ENTERPRISE]: {
    [MARKETING]: {
      title: 'merchCards.businessObjectives.suite.ENTERPRISE.MARKETING.title',
      subtext: 'merchCards.businessObjectives.suite.ENTERPRISE.MARKETING.subtext_jsx',
      extraQuantityUnits: 'merchCards.businessObjectives.suite.ENTERPRISE.MARKETING.extra_jsx'
    },
    [SALES]: {
      title: 'merchCards.businessObjectives.suite.ENTERPRISE.SALES.title',
      subtext: 'merchCards.businessObjectives.suite.ENTERPRISE.SALES.subtext_jsx',
      seatsSubtext: 'merchCards.businessObjectives.suite.ENTERPRISE.SALES.seats_jsx'
    },
    [SERVICE]: {
      title: 'merchCards.businessObjectives.suite.ENTERPRISE.SERVICE.title',
      subtext: 'merchCards.businessObjectives.suite.ENTERPRISE.SERVICE.subtext_jsx',
      seatsSubtext: 'merchCards.businessObjectives.suite.ENTERPRISE.SERVICE.seats_jsx'
    },
    [CMS]: {
      title: 'merchCards.businessObjectives.suite.ENTERPRISE.CMS.title'
    },
    [OPERATIONS]: {
      title: 'merchCards.businessObjectives.suite.ENTERPRISE.OPERATIONS.title'
    }
  }
};
export const StarterCrmSuiteBOTranslationKeys = ['splash-page.bundles.starterCrmSuiteCard.businessObjectives.captureAndConvert', 'splash-page.bundles.starterCrmSuiteCard.businessObjectives.streamlineOutreach', 'splash-page.bundles.starterCrmSuiteCard.businessObjectives.supportCustomers', 'splash-page.bundles.starterCrmSuiteCard.businessObjectives.improvePerformance', 'splash-page.bundles.starterCrmSuiteCard.businessObjectives.efficiencyAndProductivity'];